export const getStringValue = (
  value?: unknown,
  defaultValue?: string
): string =>
  typeof value === "string" || typeof value === "number"
    ? String(value)
    : defaultValue || "";
